import { DefinedTuple } from "../types/defined-tuple";
import { Tuple } from "../types/tuple";

/** Permet de mettre à disposition des méthodes pour aider à manipuler des tuples. */
export abstract class TupleHelper {
	//#region METHODS

	private constructor() {}

	public static filterDefinedTuples<T, U>(paTuples: Array<Tuple<T, U>> | undefined): Array<DefinedTuple<T, U>> {
		if (!paTuples) return [];

		return paTuples.filter(
			(poTuple: Tuple<T, U>): poTuple is DefinedTuple<T, U> =>
				poTuple[0] !== undefined && poTuple[0] !== null && poTuple[1] !== undefined && poTuple[1] !== null
		);
	}

	public static getFirstElements<T, U>(paTuples: Array<Tuple<T, U>> | undefined): T[] {
		return this.getElements(paTuples, 0);
	}

	public static getSecondElements<T, U>(paTuples: Array<Tuple<T, U>> | undefined): U[] {
		return this.getElements(paTuples, 1);
	}

	private static getElements<T, U>(paTuples: Array<Tuple<T, U>> | undefined, pnIndex: 0): T[];
	private static getElements<T, U>(paTuples: Array<Tuple<T, U>> | undefined, pnIndex: 1): U[];
	private static getElements<T, U>(paTuples: Array<Tuple<T, U>> | undefined, pnIndex: 0 | 1): (T | U)[] {
		if (!paTuples) return [];

		return paTuples.map((poTuple: Tuple<T, U>): T | U => poTuple[pnIndex]);
	}

	//#endregion METHODS
}
